import { useCallback } from 'react';

interface UseCopyToClipboardReturn {
  copyToClipboard: (text: string, onSuccess?: () => void, onError?: (error: Error) => void) => Promise<void>;
}

export const useCopyToClipboard = (): UseCopyToClipboardReturn => {
  const copyToClipboard = useCallback(
    async (text: string, onSuccess?: () => void, onError?: (error: Error) => void) => {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text);
          if (onSuccess) {
            onSuccess();
          }
        } else {
          const textArea = document.createElement('textarea');
          textArea.value = text;
          textArea.style.position = 'fixed';
          textArea.style.left = '-999999px';
          textArea.style.top = '-999999px';
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          
          try {
            document.execCommand('copy');
            if (onSuccess) {
              onSuccess();
            }
          } catch (err) {
            throw new Error('Clipboard API not supported');
          } finally {
            document.body.removeChild(textArea);
          }
        }
      } catch (error) {
        const err = error instanceof Error ? error : new Error('Failed to copy to clipboard');
        if (onError) {
          onError(err);
        }
      }
    },
    []
  );

  return {
    copyToClipboard,
  };
};

